import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorPages } from '../enums/error-pages.enum';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly allowedErrorPages = [ErrorPages.E500];

  constructor(private readonly router: Router) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (this.allowedErrorPages.includes(err.status)) {
          this.router.navigate([`/${err.status}`], { state: { errorUrl: this.router.url } });
        }
        // Pass the error on as it is, so the caller can handle it. Never re-send the request here:
        // it would apply a failed POST, PUT, PATCH or DELETE a second time.
        return throwError(() => err);
      })
    );
  }
}
